import { HttpHeaders } from '@angular/common/http';

export function getBearerToken(): string | null {
    let token = localStorage.getItem('auth_token') || localStorage.getItem('accessToken');
    if (!token) {
        return null;
    }
    if (token.startsWith('"') && token.endsWith('"')) {
        token = token.slice(1, -1);
    }
    return token;
}

export function getAuthHttpHeaders(): HttpHeaders {
    const token = getBearerToken();
    if (!token) {
        return new HttpHeaders();
    }
    return new HttpHeaders({ Authorization: `Bearer ${token}` });
}

export function getAuthHttpOptions(): { headers: HttpHeaders } {
    return { headers: getAuthHttpHeaders() };
}
